import React from 'react';
import { defaultTheme, ThemeProvider, withTheme } from '../_lib/style';

export function ApplicationTheme(props: any) {
  const { theme } = props;
  if (theme) {
    const style = document.createElement('style');
    style.setAttribute('id', 'ApplicationTheme');
    document.head.appendChild(style);
    const stylesheet = style.sheet;
    if (theme.font) {
      (stylesheet as CSSStyleSheet).insertRule(
        '.elmo-elements { font-family:' + theme.font + '}',
        0
      );
    }
  }

  return <></>;
}

ApplicationTheme.defaultProps = defaultTheme;

export default withTheme(ApplicationTheme);
export { ThemeProvider, defaultTheme };
